export const checkValidation = <T extends Record<string, unknown>>(
  object: T,
): {
  errors: Record<keyof T, boolean>
  error: boolean
} => {
  const errors: Record<keyof T, boolean> = {} as Record<keyof T, boolean>
  let error = false

  for (const property in object) {
    const value = object[property]

    if (typeof value === 'string' && !value.trim()) {
      errors[property] = true
      error = true
    }

    if (Array.isArray(value) && value.length === 0) {
      errors[property] = true
      error = true
    }
  }

  return {errors, error}
}

export const validationUtil = {checkValidation} as const
